/**
 * R2 asset URL constants.
 *
 * All static images that used to live under `src/assets/` (and a few
 * from `public/images/`) now live in the `orbrasil-media` R2 bucket
 * under the `frontend/` prefix. Served via the custom domain for edge
 * caching + long-lived Cache-Control headers.
 *
 * Why constants instead of raw strings everywhere:
 *   - Single source of truth when the CDN host changes
 *   - Typed imports catch typos at compile time
 *   - Grep for usages the same way as the old `import x from "@/assets/..."`
 *
 * Uploaded via scripts/upload-static-to-r2.mjs. To update an image:
 *   1. Drop the replacement at src/assets/<path> (or temp location)
 *   2. Run the upload script — it overwrites the R2 key
 *   3. CF edge cache may take up to 60s to pick up the new version; if
 *      you need an instant swap, purge the asset URL from the CF cache.
 */

const CDN = 'https://media.orbrasil.milgrom.com.br/frontend';

// --- Industries -----------------------------------------------------------
export const industryAeronauticoImg = `${CDN}/industries/aeronautico.jpg`;
export const industryAutomotivoImg = `${CDN}/industries/automotivo.jpg`;
export const industryConstrucaoImg = `${CDN}/industries/construcao.jpg`;
export const industryEletroeletronicoImg = `${CDN}/industries/eletroeletronico.jpg`;
export const industryHospitalarImg = `${CDN}/industries/hospitalar.jpg`;
export const industryImplementosRodoviariosImg = `${CDN}/industries/implementos-rodoviarios.jpg`;
export const industryMaquinasAgricolasImg = `${CDN}/industries/maquinas-agricolas.jpg`;
export const industryMetalurgicaImg = `${CDN}/industries/metalurgica.jpg`;
export const industryOnibusCaminhoesImg = `${CDN}/industries/onibus-caminhoes.jpg`;
export const industryRefrigeracaoImg = `${CDN}/industries/refrigeracao.jpg`;

// --- Product families (catalog section imagery) ---------------------------
export const productAssistenciaImg = `${CDN}/products/assistencia.jpg`;
export const productAutocravantesImg = `${CDN}/products/autocravantes.jpg`;
export const productConsultoriaImg = `${CDN}/products/consultoria.jpg`;
export const productMaquinasSoldaImg = `${CDN}/products/maquinas-solda.jpg`;
export const productPinosSoldaImg = `${CDN}/products/pinos-solda.jpg`;
export const productPorcaTuboImg = `${CDN}/products/porca-tubo.jpg`;
export const productRebitadeirasImg = `${CDN}/products/rebitadeiras.jpg`;
export const productRebitadeirasManuaisImg = `${CDN}/products/rebitadeiras-manuais.jpg`;
export const productRebitesImg = `${CDN}/products/rebites.jpg`;
export const productRebitesBulbImg = `${CDN}/products/rebites-bulb.jpg`;
export const productRebitesEstruturaisImg = `${CDN}/products/rebites-estruturais.jpg`;
export const productRebitesHermeticosImg = `${CDN}/products/rebites-hermeticos.jpg`;
export const productRebitesRepuxoImg = `${CDN}/products/rebites-repuxo.jpg`;
export const productRebitesRoscaInternaImg = `${CDN}/products/rebites-rosca-interna.jpg`;
export const productRebitesSemiEstruturaisImg = `${CDN}/products/rebites-semi-estruturais.jpg`;
export const productRebitesUfixSteelfixImg = `${CDN}/products/rebites-ufix-steelfix.jpg`;
export const productSuporteImg = `${CDN}/products/suporte.jpg`;

// --- Brand (logo, ISO seal, hero) -----------------------------------------
//
// Only the dark SVG is referenced today (Footer). The PNG variants and
// the light SVG were dropped 2026-05-10 (knip-confirmed unused), along
// with the Media / Reference / Rebite head-type icon sections that
// pre-dated the SpecIcon catalog and the lazy ModelSpecTable chunk
// migration. Restore from git history if any of those URL strings
// are needed again.
export const logoOrBrasilDarkSvg = `${CDN}/logo-or-brasil-dark.svg`;
// PageSpeed PR8: ISO 9001 seal was a 124 KB PNG on R2 displayed at
// 64×64 — biggest single contributor to "Improve image delivery"
// (160 KiB savings flagged). Re-encoded to 256×256 WebP locally:
// 19.8 KB. Vite content-hashes the local import so the cache header
// is the immutable forever-cache from the worker.
import seloIso9001Webp from "@/assets/selo-iso-9001.webp";
export const seloIso9001Img = seloIso9001Webp;

// --- Helmet og:image (absolute, CDN-hosted) -------------------------------
/** Canonical site-wide og:image. Replaces OG_IMAGE_DEFAULT. */
export const OG_IMAGE_DEFAULT = `${CDN}/logo-or-brasil.png`;
